import React from "react";

const SkeletonAspirasi = () => {
  return (
    <div className="rounded-xl shadow-md border p-4 flex flex-col items-center bg-white animate-pulse">
      {/* Foto */}
      <div className="w-40 h-56 bg-gray-300 rounded-lg mb-4" />

      {/* Nama */}
      <div className="w-32 h-5 bg-gray-300 rounded mb-2" />

      {/* Jabatan */}
      <div className="w-24 h-4 bg-gray-200 rounded mb-4" />

      {/* Tombol */}
      <div className="w-28 h-10 bg-gray-300 rounded-lg" />
    </div>
  );
};

const SkeletonGrid = () => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
      {[...Array(4)].map((_, i) => (
        <SkeletonAspirasi key={i} />
      ))}
    </div>
  );
};

export default SkeletonGrid;
